import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const EducationSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M6 16.7586V10H18V16.7586C18 16.7586 15.6725 19 12 19C8.32746 19 6 16.7586 6 16.7586Z"
				fill="url(#paint0_linear_13382_131585)"
			/>
			<path d="M12 13L2 8.99999L12 5L22 8.99999L12 13Z" fill="#4A4A4A" />
			<path d="M12 8.5L16 11L16 15" stroke="white" strokeLinecap="round" />
			<defs>
				<linearGradient
					id="paint0_linear_13382_131585"
					x1="12"
					y1="10"
					x2="12"
					y2="23.5172"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5B91FE" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
			</defs>
		</svg>
	)
})
